module.exports = __webpack_public_path__ + "img/leadlovers.77ab1d68.svg";